import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';

class Login extends Component {
  static propTypes = {
    handleLogin: PropTypes.func.isRequired,
    user: PropTypes.object
  };

  static defaultProps = {
    user: undefined
  };

  state = {
    login: '',
    password: ''
  };

  onLoginChange = (ev) => {
    this.setState({ login: ev.target.value });
  };

  onPasswordChange = (ev) => {
    this.setState({ password: ev.target.value });
  };

  handleSubmit = (ev) => {
    ev.preventDefault();
    const { login, password } = this.state;
    this.props.handleLogin({ variables: { login, password } })
      .then(({ data }) => {
        if (!data && !data.login && !data.login.token) { return false; }
        window.localStorage.setItem('token', data.login.token);
        return data.login.token;
      });
  };

  render() {
    if (this.props.user) { return <Redirect to='/' />; }

    return (
      <div className="app flex-row align-items-center">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col col-md-5">
              <div className='card'>
                <div className="card-body">

                  <form onSubmit={this.handleSubmit}>
                    <h1>Вхід</h1>
                    <p className="text-muted">Увійдіть в адмін-панель</p>

                    <div className="mb-3 input-group">
                      <div className="input-group-addon"><i className="fa fa-user" /></div>
                      <input
                        onChange={this.onLoginChange}
                        value={this.state.login}
                        type="text"
                        placeholder="Ім'я користувача"
                        className="form-control"
                      />
                    </div>

                    <div className="mb-4 input-group">
                      <div className="input-group-addon"><i className="fa fa-lock" /></div>
                      <input
                        onChange={this.onPasswordChange}
                        value={this.state.password}
                        type="password"
                        placeholder="Пароль"
                        className="form-control"
                      />
                    </div>

                    <button type='submit' className="px-4 btn btn-primary">Увійти</button>
                  </form>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/components/Login/component.js